/**
 * @generated SignedSource<<fdb83add5556366759828244a1d53572>>
 * @relayHash 78ecee4089407539081c39e81a7b063c
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-finding/542.0.0-2026-01-13T16:17:29.153Z/useFavoritesNudgeQuery

import { ConcreteRequest } from 'relay-runtime';
export type useFavoritesNudgeQuery$variables = {
  fetchHeartPortfolioMatches: boolean;
  itemId: string;
  userId: string;
};
export type useFavoritesNudgeQuery$data = {
  readonly viewer: {
    readonly heartPortfolioMatches?: ReadonlyArray<{
      readonly item: {
        readonly serviceId: string | null;
      } | null;
    } | null> | null;
    readonly heartPortfolios: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly items: {
            readonly totalResults: number | null;
          } | null;
        } | null;
      } | null> | null;
    } | null;
  };
};
export type useFavoritesNudgeQuery = {
  response: useFavoritesNudgeQuery$data;
  variables: useFavoritesNudgeQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fetchHeartPortfolioMatches"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "itemId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userId"
},
v3 = {
  "kind": "Literal",
  "name": "first",
  "value": 1
},
v4 = {
  "kind": "Literal",
  "name": "portfolioTypes",
  "value": [
    "HEART"
  ]
},
v5 = {
  "items": [
    {
      "kind": "Variable",
      "name": "userIds.0",
      "variableName": "userId"
    }
  ],
  "kind": "ListValue",
  "name": "userIds"
},
v6 = [
  (v3/*: any*/),
  (v4/*: any*/),
  (v5/*: any*/)
],
v7 = {
  "alias": null,
  "args": [
    (v3/*: any*/)
  ],
  "concreteType": "PortfolioItemsConnection",
  "kind": "LinkedField",
  "name": "items",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "totalResults",
      "storageKey": null
    }
  ],
  "storageKey": "items(first:1)"
},
v8 = [
  {
    "items": [
      {
        "kind": "Variable",
        "name": "itemIds.0",
        "variableName": "itemId"
      }
    ],
    "kind": "ListValue",
    "name": "itemIds"
  },
  (v4/*: any*/),
  (v5/*: any*/)
],
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "useFavoritesNudgeQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": "heartPortfolios",
            "args": (v6/*: any*/),
            "concreteType": "PortfoliosConnection",
            "kind": "LinkedField",
            "name": "portfolios",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "PortfoliosEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PortfolioV2",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "condition": "fetchHeartPortfolioMatches",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "heartPortfolioMatches",
                "args": (v8/*: any*/),
                "concreteType": "PortfolioItemV2",
                "kind": "LinkedField",
                "name": "portfolioItemMatches",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Item",
                    "kind": "LinkedField",
                    "name": "item",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "useFavoritesNudgeQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": "heartPortfolios",
            "args": (v6/*: any*/),
            "concreteType": "PortfoliosConnection",
            "kind": "LinkedField",
            "name": "portfolios",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "PortfoliosEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PortfolioV2",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      (v10/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "condition": "fetchHeartPortfolioMatches",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "heartPortfolioMatches",
                "args": (v8/*: any*/),
                "concreteType": "PortfolioItemV2",
                "kind": "LinkedField",
                "name": "portfolioItemMatches",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Item",
                    "kind": "LinkedField",
                    "name": "item",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/),
                      (v10/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v10/*: any*/)
                ],
                "storageKey": null
              }
            ]
          },
          (v10/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-finding/542.0.0-2026-01-13T16:17:29.153Z/useFavoritesNudgeQuery",
    "metadata": {},
    "name": "useFavoritesNudgeQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "e32b180c4e94bd01f999d77332bbd1fa";

export default node;
